module.exports = __webpack_public_path__ + "img/edit-white.d74e10bc.svg";